import { useCallback } from 'react';
/**
 * Click handler for the editor container that covers the gap before the Lexical
 * editor has hydrated.
 *
 * While the editor's plugins are still loading, the editor instance and its root
 * click listener are not yet attached, so a click on the container would be
 * dropped. This fallback forwards that click so the input still activates —
 * opening the suggest menu and autofocusing. Once the editor is ready, Lexical's
 * own root click listener takes over and this no-ops.
 */
export const usePreHydrationClickFallback = ({ editor, onClick, }) => {
    const isEditorReady = editor !== null;
    return useCallback((e) => {
        if (!isEditorReady)
            onClick?.(e.nativeEvent);
    }, [isEditorReady, onClick]);
};
//# sourceMappingURL=usePreHydrationClickFallback.js.map